import {getTestProps} from '@benchling/js-test-utils';
import {ActionIcon, Tooltip} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface ToggleAnalysisSidebarButtonProps {
  sidebarIsOpen: boolean;
  toggleSidebar: () => void;
}

export default function ToggleAnalysisSidebarButton({
  sidebarIsOpen,
  toggleSidebar,
}: ToggleAnalysisSidebarButtonProps): JSX.Element {
  return (
    <Tooltip
      label={sidebarIsOpen ? 'Close sidebar' : 'Open sidebar'}
      withArrow={true}
      arrowSize={18}
      withinPortal={true}
    >
      <ActionIcon
        onClick={toggleSidebar}
        {...getTestProps({component: 'ToggleAnalysisSidebarButton', element: 'root'})}
      >
        <BenchlingIcon icon={sidebarIsOpen ? 'chevron-left' : 'chevron-right'} />
      </ActionIcon>
    </Tooltip>
  );
}
